// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: '5awrwVvXqN73dsMaAIZg2DnTeLrQvaQa'
})

Vue.config.productionTip = false
Vue.use(ElementUI);




new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js